import { Png } from "common/assets"
import { Styled } from "components/Styled"
import { ButtonApp, ImageApplication, StyledButtonsWrapper } from "./styled"

export const ButtonsWrapper = () => {
    const handleAppClick = () => {
        console.log('App Store');
    }
    const handleGoogleClick = () => {
        console.log('Google Pay');
    }


    return (
        <StyledButtonsWrapper>
            <ButtonApp type='button' onClick={handleAppClick}>
                <ImageApplication src={Png.App} alt="app store" />
            </ButtonApp>
            <ButtonApp type='button' onClick={handleGoogleClick}>
                <ImageApplication src={Png.Google} alt="google play" />
            </ButtonApp>

        </StyledButtonsWrapper>
    )
}